import { store } from '@operato/shell'

import context from './reducers/context'

export default function bootstrap() {
  store.addReducers({
    context
  })
}
